<template>
	<div class="SNMedicalWidget">
		<div class="row">
			<div class="col-xs-12">
				<panel-basic :title="title"
					:helpText="helpText"
					:collapsable="true"
					id="panel"
					class="rounded-top"
					panel-class="full-height"
					style="border-radius: 25px;">
					<div class="row">
						<div class="col-xs-12 col-md-4"
								 v-for="(type, typeIndex) in formData[formType]"
								 :key="`formType_${typeIndex}_${changeTicker}`">
							<ValidationProvider ref="provider">
								<label :for="getCode(type)" :style="getSelectStyle(type)">{{ getDescription(type) }}</label>
								<select :name="getCode(type)"
												:aria-label="getCode(type)"
												:style="getSelectStyle(type)"
												class="form-control"
												:key="`${getCode(type)}_${getValue(type)}_select`"
												:value="getValue(type)"
												@input="setValue(type, $event.target.value)"
												:disabled="isReadOnly">
									<option value="N">{{ noText }}</option>
									<option value="Y">{{ yesText }}</option>
								</select>
							</ValidationProvider>
						</div>
					</div>
				</panel-basic>
			</div>
		</div>
	</div>
</template>

<script>
	import PanelBasic from '../panels/PanelBasic.vue';
	import { ValidationProvider } from 'vee-validate';
	export default {
		name: 'SNMedicalWidget',
		props: {
			formData: {
				type: Object,
				required: true
			},
			formType: {
				type: String,
				required: true
			},
			title: {
				type: String,
				defualt: ''
			},
			helpText: {
				type: String,
				default: "",
			},
			yesText: {
				type: String,
				defualt: "Yes"
			},
			noText: {
				type: String,
				defualt: "No"
			},
            isReadOnly:{
                type:Boolean,
                default:false
            }
		},
		data(){
			return {
				changeTicker: 0,
			};
		},
		components: {
			PanelBasic,
			ValidationProvider
		},
		methods: {
			getSelectStyle(type){
				if( this.getValue(type) === 'N' ){
					return { color: 'gray' };
				} else {
					return {};
				}
			},
			getValue(type){
				if( !!this.formData.DATA[this.getCode(type)] ){
					return this.formData.DATA[this.getCode(type)];
				} else if ( this.formType === 'STANDING_ORDERS' && !!this.formData[this.formType] && !!this.formData[this.formType][this.getCode(type)] ){
					return this.formData[this.formType][this.getCode(type)].ALLOWED_FLG;
				} else if( !!this.formData[this.formType] && !!this.formData[this.formType][this.getCode(type)] ){
					return this.formData[this.formType][this.getCode(type)].ACTIVE_FLG;
				} else {
					return "";
				}
			},
			setValue(type, value){
				this.formData.DATA[this.getCode(type)] = value;
				this.changeTicker = this.changeTicker + 1;
			},
			getCode(type) {
				return !!type.CONDITION_CODE ? type.CONDITION_CODE : type.MEDICATION_CODE;
			},
			getDescription(type) {
				return !!type.MED_CONDITION_DESC ? type.MED_CONDITION_DESC : type.MEDICATION_DESC;
			}
		}
	}
</script>
